import { useEffect, useState, createElement, forwardRef, useRef } from "react";
import './index.scss';
const ColorfulSelect = forwardRef(({ label = '标题', placeholder = '输入文本', options, optionsShow, textAlign = 'left', required = false, separate = false, isHideLabel = false, labelWidth, disabled, isError, onChange, ...otherProps }, ref) => {
    const selectClass = separate ? 'au-select-separate' : '';
    const alignClass = `au-select-${textAlign}`;
    const labelFixWidth = labelWidth ? `${labelWidth}px` : 'auto';
    const statusClass = isError ? 'au-select-error' : '';
    const _otherProps = otherProps || {};
    const [selectedClass, setselectedClass] = useState('');
    const [size, setSize] = useState(1);
    const handleChange = (e) => {
        setselectedClass('inner-active');
        if (onChange) {
            onChange(e);
        }
    };
    const handleFocus = () => {
        setselectedClass('inner-active');
    };
    useEffect(() => {
        if (optionsShow) {
            setselectedClass('inner-active');
            setSize(3);
        }
        else {
            setselectedClass('');
            setSize(1);
        }
    }, [optionsShow]);
    const nativeSelectRef = useRef(null);
    return (createElement("div", { className: `au-select ${selectClass} ${alignClass} ${statusClass}`, ..._otherProps },
        !isHideLabel && createElement("label", { className: 'inner-label', style: { width: labelFixWidth } },
            required ? createElement("span", { className: "required-title" }, "*") : '',
            label || '标题'),
        createElement("select", { size: size, ref: ref || nativeSelectRef, className: `inner-select ${selectedClass}`, disabled: disabled, onChange: handleChange, onFocus: handleFocus },
            createElement("option", { value: "", className: "placeholder-txt" }, placeholder || '请选择'),
            options?.map(_ => { return createElement("option", { value: _?.value }, _?.label); })),
        createElement("label", { className: "select-angle-right" },
            createElement("i", { className: `icon-angle-right ${selectedClass}` })),
        isError && createElement("i", { className: "icon-exclamation-circle" })));
});
ColorfulSelect.displayName = 'ColorfulSelect';
export default ColorfulSelect;
